import React, { useState, useEffect } from 'react';
import { fetchFeatures, fetchClientTypes } from './useApi';
import {
  FormControl,
  Alert,
  InputLabel,
  TextField,
  Button,
  Checkbox,
  MenuItem,
  ListItemText,
  Select,
  OutlinedInput,
  IconButton,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import MultiSelect from './MultiSelect'; // Import the MultiSelect component
import { submitLocationRequest } from './useApi';

const AddNewLocationRequest = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [website, setWebsite] = useState('');
  const [email, setEmail] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [latitudeLongitudeString, setLatitudeLongitudeString] = useState('');
  const [facilities, setFacilities] = useState<string>('');
  const [amenities, setAmenities] = useState<string[]>([]);
  const [facilityOptions, setFacilityOptions] = useState<{ id: string; name: string }[]>([]);
  const [amenityOptions, setAmenityOptions] = useState<{ id: string; name: string }[]>([]);

    const [selectedClientTypesOptions, setSelectedClientTypesOptions] = useState<{ id: string; name: string }[]>([]);
    const [selectedClientType, setSelectedClientType] = useState<string>('0');
  
    const [selectedFeaturesOptions, setSelectedFeaturesOptions] = useState<{ id: string; name: string }[]>([]);
    const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);
    const [isEmailHelpOpen, setIsEmailHelpOpen] = useState(false);
    const [submitSuccessMessage, setSubmitSuccessMessage] = useState<string | null>(null);
    const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);

  const handleCopyPhone = async () => {
    if (!phone.trim()) {
      return;
    }

    try {
      await navigator.clipboard.writeText(phone);
    } catch {
      const fallbackInput = document.createElement('input');
      fallbackInput.value = phone;
      document.body.appendChild(fallbackInput);
      fallbackInput.select();
      document.execCommand('copy');
      document.body.removeChild(fallbackInput);
    }
  };

  const phoneDialValue = phone.replace(/[^+\d]/g, '');

 

  useEffect(() => {
    async function fetchOptions() {
      // Fetch facilities and amenities options
      const facilitiesData = await fetchFeatures();
      const amenitiesData = await fetchClientTypes();

      const mappedFacilities = facilitiesData.map((facility: any) => ({
        id: facility.featureID,
        name: facility.name,
      }));

      const mappedAmenities = amenitiesData.map((amenity: any) => ({
        id: amenity.clientTypeID,
        name: amenity.name,
      }));

      loadClientTypesAndSetFacilities();

    //   setFacilityOptions(mappedFacilities);
    //   setAmenityOptions(mappedAmenities);
    }

    // fetchOptions();

        async function loadClientTypesAndSetFacilities() {
        try {
            const clientTypes = await fetchClientTypes();
            const mappedClientTypes = clientTypes.map((clientType: any, idx: number) => ({
                id: clientType.clientTypeID,
                name: clientType.name
            }));
            setSelectedClientTypesOptions(mappedClientTypes);

            if (mappedClientTypes.length > 0) {
                setSelectedClientType(mappedClientTypes[0].id);
            }

            const features = await fetchFeatures();
            const mappedFeatures = features.map((feature: any, idx: number) => ({
                id: feature.featureID,
                name: feature.name
            }));
            setSelectedFeaturesOptions(mappedFeatures);

        }
        catch (error) {
            console.error('Error loading client types and features:', error);
        }

    }  

    loadClientTypesAndSetFacilities();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitSuccessMessage(null);
    setSubmitErrorMessage(null);

    const requestData = {
      name,
      description,
      email,
      contactEmail,
      website,
      phone,
      latitudeLongitudeString,
      clientTypeID: selectedClientType,
      clientRequestFeatureIDs: selectedFeatures
    };
    
    try {
      await submitLocationRequest(requestData); // Call the API function
      setSubmitSuccessMessage('Request submitted successfully!');
      setName('');
      setDescription('');
      setWebsite('');
      setEmail('');
      setContactEmail('');
      setPhone('');
      setLatitude('');
      setLongitude('');
      setLatitudeLongitudeString('');
      setFacilities('');
      setAmenities([]);
      setSelectedFeatures([]);
      setSelectedClientType(selectedClientTypesOptions[0]?.id ?? '0');
      setIsEmailHelpOpen(false);
    } catch (error: any) {
      setSubmitErrorMessage(`Failed to submit location request. Try again later.`);
    }
  };

  return (
    <section className="f4k-page pending-page add-location-page">
      <div className="f4k-panel add-location-panel">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} wrap="wrap">
            {submitSuccessMessage && (
              <Grid item xs={12}>
                <Alert severity="success">{submitSuccessMessage}</Alert>
              </Grid>
            )}
            {submitErrorMessage && (
              <Grid item xs={12}>
                <Alert severity="error">{submitErrorMessage}</Alert>
              </Grid>
            )}
            <Grid item xs={12}>
                <h3 className="f4k-title">Add a Kid-Friendly Place</h3>
            </Grid>
          <Grid item xs={12}>
            <TextField
              label="Name of the place"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              margin="normal"
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description of the place"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              margin="normal"
              multiline
              rows={4}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Latitude and Longitude"
              value={latitudeLongitudeString}
              onChange={(e) => setLatitudeLongitudeString(e.target.value)}
              fullWidth
              margin="normal"
              required
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>
          {/* <Grid item xs={12} md={3}>
            <TextField
              label="Longitude"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
              fullWidth
              margin="normal"
              required
            />
          </Grid> */}
          <Grid item xs={12}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Facilities</InputLabel>
              <Select
                value={selectedClientType}
                onChange={(e) => setSelectedClientType(e.target.value)}
                input={<OutlinedInput label="Facilities" />}
                sx={{ borderRadius: '12px' }}
              >
                {selectedClientTypesOptions.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
            <Grid item xs={12}>
                <MultiSelect
                    label="Amenities"
                    options={selectedFeaturesOptions} // Pass the options for amenities
                    selected={selectedFeatures} // Pass the selected amenities
                    setSelected={setSelectedFeatures} // Pass the state setter for amenities
                />
            </Grid>


          {/* <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Amenities</InputLabel>
              <Select
                multiple
                value={amenities}
                onChange={(e) => setAmenities(e.target.value as string[])}
                input={<OutlinedInput label="Amenities" />}
                renderValue={(selected) =>
                  amenityOptions
                    .filter((option) => selected.includes(option.id))
                    .map((option) => option.name)
                    .join(', ')
                }
              >
                {amenityOptions.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    <Checkbox checked={amenities.includes(option.id)} />
                    <ListItemText primary={option.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid> */}
          <Grid item xs={12}>
            <TextField
              label="Website"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
              helperText="Optional"
              fullWidth
              margin="normal"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              helperText="Optional"
              fullWidth
              margin="normal"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              helperText="Optional"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      type="button"
                      size="small"
                      onClick={handleCopyPhone}
                      disabled={!phone.trim()}
                      sx={{ minWidth: 'auto', px: 1 }}
                    >
                      Copy
                    </Button>
                    <Button
                      type="button"
                      size="small"
                      component="a"
                      href={phoneDialValue ? `tel:${phoneDialValue}` : undefined}
                      disabled={!phoneDialValue}
                      sx={{ minWidth: 'auto', px: 1 }}
                    >
                      Call
                    </Button>
                  </InputAdornment>
                ),
              }}
              fullWidth
              margin="normal"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Your Contact Email Address"
              type="email"
              value={contactEmail}
              required
              onChange={(e) => setContactEmail(e.target.value)}
              helperText="Optional. We'll use this email only to contact you about this request."
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip
                      open={isEmailHelpOpen}
                      onClose={() => setIsEmailHelpOpen(false)}
                      title="The email address you provide will only be used to contact you and confirm your request to add this location to the system."
                      placement="top"
                      arrow
                    >
                      <IconButton
                        type="button"
                        edge="end"
                        size="small"
                        aria-label="Why we ask for your email"
                        onClick={() => setIsEmailHelpOpen((current) => !current)}
                        sx={{
                          width: 24,
                          height: 24,
                          border: '1px solid rgba(23, 74, 49, 0.25)',
                          color: 'var(--f4k-brand-700)',
                          fontWeight: 700,
                        }}
                      >
                        ?
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              fullWidth
              margin="normal"
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
            />
          </Grid>          
          <Grid item xs={12} md={4}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: 'var(--f4k-brand-600)',
                '&:hover': { backgroundColor: 'var(--f4k-brand-700)' },
              }}
            >
              Submit Request
            </Button>
          </Grid>
        </Grid>
      </form>
      </div>
    </section>
  );
};

export default AddNewLocationRequest;